import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'firstPresentValue',
  standalone: true
})
export class FirstPresentValuePipe implements PipeTransform {

  transform(value?: unknown | null, ...values: (unknown | undefined | null)[]): any | undefined | null {
    if (value) {
      return value;
    }
    for (let i = 0; i < values.length; i++) {
      const val = values[i];
      if (val) {
        return val;
      }
    }
    return null;
  }

}
